export default function PhoneIcon() {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_126_5074)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.1085 9.91345C13.4305 9.50324 12.5491 9.04517 11.7491 9.38018C11.139 9.63314 10.7457 10.604 10.3457 11.0962C10.1424 11.3492 9.89828 11.3902 9.58642 11.2603C7.28133 10.3373 5.51862 8.78537 4.25082 6.64545C4.03388 6.31044 4.07455 6.05064 4.33218 5.74299C4.71862 5.28492 5.19998 4.77216 5.30167 4.15684C5.40337 3.54153 5.11862 2.82366 4.86777 2.27671C4.54913 1.57936 4.18303 0.581181 3.4915 0.184645C2.85421 -0.177707 2.01354 0.0273976 1.44405 0.492302C0.460994 1.29905 -0.0135821 2.56386 -2.27444e-05 3.815C-2.27444e-05 4.17052 0.0474349 4.52603 0.128791 4.86787C0.325401 5.69513 0.705062 6.46769 1.13218 7.19923C1.45082 7.75301 1.80337 8.28629 2.17625 8.80588C3.41015 10.4946 4.94235 11.9577 6.71184 13.0584C7.59998 13.6053 8.55591 14.0839 9.53896 14.4189C10.6508 14.7881 11.6339 15.171 12.8339 14.9454C14.0881 14.7061 15.322 13.9198 15.8237 12.7029C15.9729 12.3405 16.0474 11.9372 15.9593 11.5611C15.7898 10.7749 14.7322 10.3031 14.1017 9.92712L14.1085 9.91345Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_126_5074">
          <rect width="16" height="15" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
